import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "wrap", "input"]

  connect() {
    // If there's already a search query, stay expanded
    if (this.inputTarget.value.trim()) {
      this.expand()
    }
  }

  expand() {
    this.triggerTarget.hidden = true
    this.wrapTarget.hidden = false
    this.inputTarget.focus()
  }

  collapse() {
    // Only collapse if input is empty
    if (this.inputTarget.value.trim()) return
    this.wrapTarget.hidden = true
    this.triggerTarget.hidden = false
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.inputTarget.value = ""
      this.wrapTarget.hidden = true
      this.triggerTarget.hidden = false
      this.triggerTarget.focus()
    }
  }

  handleBlur() {
    // Delay to allow form submission click
    setTimeout(() => this.collapse(), 150)
  }
}
